<template>
  <!----尾部------->

  <div>
    <div class="foot">
      <div class="bodyCenter">
        <div class="left">
          <div>第二十届中国国际煤炭采矿技术交流及设备展览会组委会</div>
          <div class="msg">
            <div class="item">
              <img src="../../static/commonImg/address.png" alt="" />
              <span>北京市东城区安外大街192号煤机大厦</span>
            </div>

            <div class="item">
              <img src="../../static/commonImg/email.png" alt="" />
              <span>chinaminexpo@vip.163.com</span>
            </div>

            <div class="item">
              <img src="../../static/commonImg/phone.png" alt="" />
              <span>010-64253061</span>
            </div>

            <div class="item">
              <img src="../../static/commonImg/icon_web.png" alt="" />
              <span>www.chinaminexpo.com</span>
            </div>
          </div>
        </div>

        <div class="right">
          <div class="fastLink">
            <p>快速链接</p>

            <div class="table">
              <div>
                <a
                  href="https://www.chinaminexpo.com/hz/f/list.html?categoryId=8ff76b57a6674525a898d5ba4026352c"
                  >我要参展</a
                >
              </div>
              <div>
                <a
                  href="https://www.chinaminexpo.com/hz/f/list.html?categoryId=70b5d6c9d45245a09e51eff9b334e3c6"
                  >展会日程</a
                >
              </div>
              <div>
                <a
                  href="https://www.chinaminexpo.com/hz/f/list.html?categoryId=423d542b5b2343f1ac216b425aa7ae33"
                  >我要参观</a
                >
              </div>
              <div>
                <a href="https://www.chinaminexpo.com/hz/f">展会官网</a>
              </div>
              <div>
                <a
                  href="https://www.chinaminexpo.com/hz/f/hz/gzZwtIndex.html?categoryId=6f595480c4c74329bae5448ddf19cb8a"
                  >展位图</a
                >
              </div>
              <div></div>
            </div>
          </div>

          <div class="Qr">
            <img src="../../static/commonImg/erweiMa.png" alt="" />
          </div>
        </div>
      </div>

      <div class="company">
        <p>主办单位<span>中国煤炭工业协会</span></p>
        <p>协办单位<span>中国中煤能源集团有限公司</span></p>
        <p>主办单位<span>中国煤炭工业国际技术咨询有限责任公司</span></p>
        <p><span> 汇显展览有限公司</span></p>
        <div class="wexin">
          <div>展览会微信公众号</div>
          <div>请扫描二维码进行关注</div>
        </div>
      </div>
    </div>

    <div class="bottomBack">
      <div class="center">
        <span>版权所有：中国煤炭工业国际技术咨询有限责任公司</span>
        <span>技术支持：中煤信息技术(北京)有限公司</span>
        <span>京公网安备11010102002548号</span>
        <span>京ICP备09033595号-1</span>
        <span>Copyright © 2018. All Rights Reserved</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "footBottom",
  data() {
    return {};
  },
};
</script>
<style scoped>
.foot {
  width: 100%;
  height: 260px;
  background-image: url("../../static/index/bgimg@2x.png");
  background-position: center;
  background-size: cover;
  position: relative;
  overflow: hidden;
}
.bodyCenter {
  width: 1270px;
  box-sizing: border-box;
  margin: 0 auto;
  display: flex;
  padding-top: 51px;
  justify-content: space-between;
}
.foot .bodyCenter .left {
  width: 666px;
  font-size: 24px;
  font-family: "Microsoft YaHei";
  font-weight: 400;
  color: #ffffff;
}
.foot .bodyCenter .right {
  width: 450px;
}

.foot .bodyCenter .msg {
  padding-top: 17px;
  font-size: 14px;
  font-family: "Microsoft YaHei";
  font-weight: 400;
  color: #ffffff;
  line-height: 26px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.foot .msg .item {
  display: flex;
  justify-content: flex-start;
  padding-right: 5px;
  box-sizing: border-box;
  width: 320px;
  margin-top: 11px;
}
.foot .msg .item span {
  padding-left: 10px;
}
.foot .bodyCenter .right {
  width: 438px;
  display: flex;
  justify-content: space-between;
}
.foot .right .fastLink {
  font-size: 24px;
  font-family: "Microsoft YaHei";
  font-weight: 400;
  color: #ffffff;
  flex: 1;
}
.foot .right .table {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding-top: 33px;
}
.foot .table div {
  font-size: 14px;
  font-family: "Microsoft YaHei";
  font-weight: 400;
  color: #ffffff;
  width: 85px;
  margin-bottom: 15px;
}
.foot .right .Qr {
  width: 141px;
}
.foot .right .Qr img {
  display: block;
  margin: 0 auto;
  padding-bottom: 20px;
}
.foot .right .Qr div {
  font-size: 14px;
  font-family: "Microsoft YaHei";
  font-weight: 400;
  color: #ffffff;
  text-align: center;
  padding-top: 2px;
}
.foot .company {
  width: 1270px;
  margin: 0 auto;
  display: flex;
  padding-top: 15px;
}
.foot .company p {
  padding-right: 33px;
  font-size: 14px;
  font-family: "Microsoft YaHei";
  font-weight: 400;
  color: #fdd000;
}
.foot .company p span {
  font-size: 14px;
  font-family: "Microsoft YaHei";
  font-weight: 400;
  color: #ffffff;
  padding-left: 10px;
}

.wexin {
  width: 148px;
  font-size: 14px;
  text-align: center;
  padding-left: 138px;
  position: relative;
  top: -24px;
}
.wexin div {
  padding-bottom: 5px;
  font-size: 14px;
  font-family: "Microsoft YaHei";
  font-weight: 400;
  color: #ffffff;
}
.bottomBack {
  height: 50px;
  background: #000000;
  border: 1px solid black;
}
.center {
  margin: 0 auto;
  width: 1270px;
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  font-family: "Microsoft YaHei";
  font-weight: 400;
  color: #a4cdff;
  font-size: 14px;
  line-height: 50px;
}
.table a {
  text-decoration: none;
  color: white;
}
</style>
